import { IncidentComponent } from './../incident.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Incident } from '../../models/Incident';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { StatutIncident } from '../../models/StatuIncident';
import { DialogModule } from '@angular/cdk/dialog';
import { GenericToastrService } from '../../generic-components/generic-toastr/generic-toastr.service';
import { GenericValidateComponent } from '../../generic-components/generic-validate/generic-validate.component';
import { IncidentService } from '../incident.service';
import { GenericSearchService } from '../../generic-components/generic-search/generic-search.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-incident-details',
  imports: [
    MatCardModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './incident-details.component.html',
  styleUrl: './incident-details.component.css',
})
export class IncidentDetailsComponent implements OnInit {
  incident: Incident = new Incident();
  typeEcart?: string;
  valeurEcart?: number;

  statuts: StatutIncident[] = [];

  compareFn = (a: any, b: any) =>
    a && b && a.codeStatutIncident === b.codeStatutIncident;

  form!: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private toastr: GenericToastrService,
    private incidentService: IncidentService,
    private dialogRef: MatDialogRef<IncidentDetailsComponent>,
    private search: GenericSearchService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.incident = this.data.incident;
    if (this.incident?.ecart) {
      for (const [key, value] of Object.entries(this.incident?.ecart)) {
        if (typeof value === 'number') {
          this.typeEcart = key;
          this.valeurEcart = value;
          break;
        }
      }
    }

    this.form = this.fb.group({
      statutIncident: [this.incident.statutIncident, Validators.required],
    });

    this.loadStatutIncident();
  }

  affranchirIncident() {
    const dialogRef = this.dialog.open(GenericValidateComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        libelle: 'Voulez-vous vraiment affranchir cet incident ?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.incidentService.createAffranchi(this.incident).subscribe(
          (result) => {
            this.dialogRef.close(true);
          },
          (error) => {
            this.toastr.openSnackBarProblem(error.error.message);
          }
        );
      }
    });
  }

  cancelButton() {
    this.dialogRef.close();
  }

  validateButton() {
    this.spinner.show();
    this.incidentService.updateIncident(this.incident).subscribe(
      (result) => {
        this.spinner.hide();
        this.toastr.openSnackBarSuccess(
          "L'incident a été modifié avec succés !"
        );
        this.dialogRef.close(true);
      },
      (error) => {
        this.spinner.hide();
        this.toastr.openSnackBarProblem(error.message);
        this.dialogRef.close();
      }
    );
  }

  loadStatutIncident() {
    this.search
      .search(
        'incident/statut-incident',
        'codeStatutIncident!=A',
        0,
        10,
        'codeStatutIncident=ASC'
      )
      .subscribe((result) => {
        this.statuts = result.content;
      });
  }
}
